<template>
    <b-modal id="modal-kemasan-edit" title="Edit Kemasan" variant="success" ref="modalKemasanEdit" hide-footer no-close-on-backdrop no-close-on-esc>
        <div class="row">
            <div class="col-md-6">
                <b-form-fieldset label="Jumlah Kemasan">
                    <b-form-input @input="updateKemasan('JML_KMS', $event)" :value="model('JML_KMS')" v-validate="'required'" type="number" name="Jumlah Kemasan"></b-form-input>
                    <div v-show="errors.has('Jumlah Kemasan')" class="text-danger">{{ errors.first('Jumlah Kemasan') }}</div>
                    <small>Isikan Jumlah Total Kemasan</small>
                </b-form-fieldset>
            </div>
            <div class="col-md-6">
                <b-form-fieldset label="Jenis Kemasan">
                    <model-list-select @input="updateKemasan('JNS_KMS', $event)" :value="model('JNS_KMS')" class="form-control" :list="JenisKemasan" option-value="JNS_KMS" :custom-text="(item) => `${item.JNS_KMS} - ${item.UR_KMS}`"></model-list-select>
                    <div v-show="errors.has('Jenis Kemasan')" class="text-danger">{{ errors.first('Jenis Kemasan') }} </div>
                </b-form-fieldset>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <button @click="saveUpdateKemasan()" class="btn btn-success pull-right">Simpan</button>
            </div>
        </div>
    </b-modal>
</template>
<script>
import swal from 'sweetalert'
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      JenisKemasan: [],
      kemasan: {
        jumlahKemasan: '',
        jenisKemasan: ''
      }
    }
  },
  created () {
    this.getJenisKemasan()
  },
  methods: {
    ...mapActions({
      setKemasan: 'barpin/updateKemasan'
    }),
    model (name) {
      return this.$store.state.barpin.current_kemasan[name]
    },
    getJenisKemasan () {
      this.$http.get('ref/jnskemasan').then((response) => {
        this.JenisKemasan = response.data
      })
    },
    updateKemasan (where, event) {
      this.$store.commit('barpin/UPDATE_KEMASAN', {value: event, where: where})
    },
    saveUpdateKemasan () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.commit('barpin/SET_LOADING', true)
          var dataSet = {
            ...this.$store.state.barpin.current_kemasan
          }
          this.setKemasan(dataSet).then(() => {
            this.$refs['modalKemasanEdit'].hide()
            this.$store.commit('barpin/SET_LOADING', false)
          }).catch((error) => {
            swal('error', JSON.stringify(JSON.parse(error.bodyText).errors), 'error')
            this.$store.commit('barpin/SET_LOADING', false)
          })
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/ppftz/modal/ModalKemasanEdit.vue?54df4eb7